import React from 'react'
import { useDispatch } from 'react-redux'
import { animated } from 'react-spring'
import useFadeInFromAvobe from 'hooks/useFadeInFromAvobe'
import { fetchLog } from 'context/reducer/quota'

export const ButtonQuota: React.FC = () => {
  
  const props = useFadeInFromAvobe(500)
  const dispatch = useDispatch()
  const handelOnClick = () => {
    dispatch(fetchLog())
  }

  return (
    <animated.div style={props}>
      <div className=" bp-mt-24 bp-mb-32">
        <pichincha-button class='sizebutton-loan' color="primary" href="#login-form" onClick={handelOnClick}>
          Lo quiero
        </pichincha-button>
      </div>
    </animated.div>
  )
}
